import axios from "axios";
import axiosConfig from "../../../configs/axios.config";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';



export const getAccessRoles = createAsyncThunk('AccessRoles/AccessRoles', async () => {
    try {
        const response = await axios.create(axiosConfig).get('/api/accessRoles')
        if (response.data.success) {
            return response.data.data
        }
        else {
            console.log(response.data)
        }
    }
    catch (error) {
        console.log(error)
    }
})

const AccessRolesSlice = createSlice({
    name: 'AccessRolesStatus',
    initialState: {
        dataLoading: [],
        isLoading: true
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getAccessRoles.fulfilled, (state, action) => {
            state.isLoading = false
            state.dataLoading = action.payload
        })
    }
})


//Reducer
const AccessRolesReducer = AccessRolesSlice.reducer

//Selector
export const AccessRolesSelector = (state) => state.AccessRolesReducer

//Action export
export const {

} = AccessRolesSlice.actions

export default AccessRolesReducer